import { isLive } from '.'

// Defaults locally to process.env.REDIS_URL or redis://localhost:6379
export const CACHE_REDIS_URL = isLive
  ? '//live-redis-spain-holiday-fe.holidu.cloud:6379'
  : process.env.REDIS_URL || '//dev-redis-search-frontend.holidu.io:6379'

export const ASSET_HOST = 'https://sh-assets.holidu.com'
export const OLD_IMAGE_REGEX =
  /(\/\/d1ez3020z2uu9b\.cloudfront\.net)[^\r\n\t\v\f"'#;)]*\b/gim
export const SCRIPTS_REGEX =
  /themoneytizer|Muscula|facebook|getyourguide|newsletterPopupBoxSignupButton|checkCookieBar|IEMobile|ajs.php|s_h-Services|s_h-Directives/
export const ASSETS_REGEX = /\/(pics|public|scripts|dist)\/[^\r\n\t\v\f"'#]*/gim
export const OLD_IMAGE_HOST = '//d1ez3020z2uu9b.cloudfront.net'

export const OFFLINE_PAGES = new Set([
  'www.spain-holiday.com/rentalbuzz/a-brand-you-can-trust-in',
  'www.vacaciones-espana.es/rentalbuzz/spain-holidaycom-se-adhiere-a-confianza-online',
  'www.wakacje-hiszpania.pl/Hiszpania/artykuly/najbardziej-fotogeniczne-miejsca-w-hiszpanii',
])
